import { Component, ComponentInterface, h, Host, Prop } from '@stencil/core';
import { AppHomeType } from '../app-home/app-home-types';

@Component({
  tag: 'app-firm-types',
  styleUrl: 'app-firm-types.css',
  shadow: false,
})
export class AppAppHomeType implements ComponentInterface {
  @Prop() firmType: AppHomeType;

  slidesElement: HTMLIonSlidesElement;

  readonly slidesConfig = {
    slidesPerView: 'auto',
    cssMode: false,
    autoHeight: true,
    updateOnWindowResize: true,
    allowTouchMove: true,
    simulateTouch: true,
    sliderDrag: true,
    sliderTouch: true,
    noSwiping: false,
    touchEventsTarget: 'wrapper',
    zoom: false,
    freeMode: false,
  };

  componentDidLoad() {
    // setTimeout(() => {
    //   this.updateSlides();
    // }, 3000);
  }

  updateSlides() {
    // console.log('Update Slides');
    // this.slidesElement.update();
    // this.slidesElement.updateAutoHeight();
  }

  renderCard(imageSrc: string, alt: string, title: string, subtitle: string, paragraph: string) {
    return (
      <ion-card class="ion-margin firm-slide">
        <ion-img class="firm-img" alt={alt} src={imageSrc}
          onIonImgDidLoad={(a) => this.updateSlides()}></ion-img>
        <ion-card-header class="ion-padding-top ion-text-center">
          {(!!title) ? <ion-card-title>{title}</ion-card-title> : ''}
          {(!!subtitle) ? <ion-card-subtitle>{subtitle}</ion-card-subtitle> : ''}
        </ion-card-header>
        <ion-card-content>
          {paragraph}
        </ion-card-content>
      </ion-card>
    );
  }

  renderFixed() {
    return (
      <ion-grid class="ion-no-padding firm-carrousel">
        <ion-row class="ion-no-padding">
          {this.firmType === AppHomeType.restaurante ?
            this.renderCard('/assets/img/empresa-area.webp', 'Áreas de alimentação', 'Áreas de alimentação', null, null) : null}
          {this.firmType === AppHomeType.restaurante ?
            this.renderCard('/assets/img/empresa-food-truck.webp', 'Lanchonetes e food trucks', 'Lanchonetes e food trucks', null, null) : null}
          {this.firmType === AppHomeType.restaurante ?
            this.renderCard('/assets/img/empresa-fast.webp', 'Fast-foods', 'Fast-foods', null, null) : null}

          {this.firmType === AppHomeType.transporte ?
            this.renderCard('/assets/img/empresa-carga-descarga.jpg', 'Carga e Descarga', 'Carga e Descarga', null, null) : null}
          {this.firmType === AppHomeType.transporte ?
            this.renderCard('/assets/img/empresa-transporte.jpg', 'Transportes', 'Transportes', null, null) : null}
          {this.firmType === AppHomeType.transporte ?
            this.renderCard('/assets/img/empresa-supermercado.jpg', 'Armazéns e Supermercados', 'Armazéns e Supermercados', null, null) : null}
        </ion-row>
      </ion-grid>
    );
  }

  // renderSlides() {
  //   return (
  //     <ion-slides class="firm-carrousel" options={this.slidesConfig} pager={false} ref={(el) => this.slidesElement = el}>
  //       <ion-slide class="firm-slide">{this.renderCard('', 'Restaurantes', null, '')}</ion-slide>
  //       <ion-slide class="firm-slide">{this.renderCard('', 'Clínicas e Consultórios', null, '')}</ion-slide>
  //       <ion-slide class="firm-slide">{this.renderCard('', 'Carga e Descarga', null, '')}</ion-slide>
  //       <ion-slide class="firm-slide">{this.renderCard('', 'Supermercados', null, '')}</ion-slide>
  //       <ion-slide class="firm-slide">{this.renderCard('', 'Agências Bancárias', null, '')}</ion-slide>
  //       <ion-slide class="firm-slide">{this.renderCard('', 'Restaurantes', null, '')}</ion-slide>
  //     </ion-slides>
  //   );
  // }

  render() {
    return (
      <Host>
        <div id="tipos-empresas" class="block-container firm-types-container">
          <ion-text class="features-header" color="light">
            <h2 class="center-title text-shadow">Ideal para o seu negócio</h2>
          </ion-text>
          {this.renderFixed()}
          {/* {this.renderSlides()} */}

        </div>
      </Host>
    );
  }

}
